// В.2.h-rebalance: Главврач Ариана — активка «Эвакуация».
// «Сними одного союзного юнита с поля в руку. При возвращении в руку юнит
//  полностью излечивается, временные баффы сброшены, постоянные сохранены».
//
// Picker: свой юнит на поле (не Герой). Если своих нет — активка не
// срабатывает (флаг heroActiveUsed не ставится).
//
// Эффект: evacuateUnitToHand — снимает юнита, кладёт в руку владельца с
// «свежим» состоянием (current = base + сохранённые permanentBuffs/keywords),
// без Модов, без временных баффов, без молчания. Юнит можно потом снова
// разыграть в Ф2.
//
// Бот: автовыбор «самый раненый» свой юнит (тай-брейк через rng).

import { evacuateUnitToHand } from './evacuate.js';
import { HERO_ID } from './arena.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

registerImplementedAbility(HERO_ID, 'active');

const LABEL = 'Ариана (active)';

export { HERO_ID };

export function getArenaActiveTargets(state, playerIdx) {
  const me = state?.players?.[playerIdx];
  if (!me) return [];
  return me.unitsOnField().filter(u => u.type === 'unit' && u.isAlive());
}

export function arenaActiveAvailable(state, playerIdx) {
  const p = state?.players?.[playerIdx];
  if (!p || p.hero?.id !== HERO_ID) return false;
  if (p.heroActiveUsed) return false;
  if (p.hero.hp <= 0) return false;
  if (getArenaActiveTargets(state, playerIdx).length === 0) return false;
  return true;
}

// targetInstanceId — выбранный игроком юнит. Бот: при null — автовыбор.
export function arenaActive(state, playerIdx, targetInstanceId = null) {
  if (!arenaActiveAvailable(state, playerIdx)) {
    return { ok: false, reason: 'unavailable' };
  }
  const me = state.players[playerIdx];
  const candidates = getArenaActiveTargets(state, playerIdx);
  let target = null;
  if (targetInstanceId != null) {
    target = candidates.find(u => u.instanceId === targetInstanceId) || null;
    if (!target) return { ok: false, reason: 'invalid_target' };
  } else {
    // Бот-автовыбор: самый раненый (макс. абсолютный недобор), тай-брейк rng.
    let maxDeficit = -Infinity;
    for (const u of candidates) {
      const cur = u.current?.hp ?? 0;
      const max = u.base?.hp ?? 0;
      const def = max - cur;
      if (def > maxDeficit) maxDeficit = def;
    }
    const tied = candidates.filter(u => {
      const cur = u.current?.hp ?? 0;
      const max = u.base?.hp ?? 0;
      return (max - cur) === maxDeficit;
    });
    target = tied.length === 1 ? tied[0] : tied[state.rng.int(tied.length)];
  }
  state.log?.add(`🪖 ${LABEL} [${me.name}]: эвакуация ${target.name_ru} в руку`);
  const r = evacuateUnitToHand(state, playerIdx, target, LABEL);
  if (!r.ok) return { ok: false, reason: r.reason || 'evacuate_failed' };
  me.heroActiveUsed = true;
  return { ok: true, target, burned: !!r.burned };
}
